import { FilterActionTypes } from "./actionTypes";

export const setFilter = ({ name, op, values, custom_field_id }) => ({
  type: FilterActionTypes.SET_FILTER,
  payload: { name, op, values, custom_field_id },
});

export const resetFilters = () => ({
  type: FilterActionTypes.RESET,
});

export const setActiveFilter = ({ name }) => ({
  type: FilterActionTypes.SET_ACTIVE_FILTER,
  payload: { name },
});

export const setTagsOperator = ({ operator }) => ({
  type: FilterActionTypes.SET_TAGS_OPERATOR,
  payload: { operator },
});

export const setWithoutTagsOperator = ({ operator }) => ({
  type: FilterActionTypes.SET_WITHOUT_TAGS_OPERATOR,
  payload: { operator },
});
